var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCouponBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 171,
    viewBox: "0 0 343 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323 0C334.046 0 343 8.95431 343 20V151C343 162.046 334.046 171 323 171H20C8.95431 171 8.05374e-08 162.046 0 151V148C6.62742 148 12 142.627 12 136C12 129.373 6.62742 124 0 124V114C6.62742 114 12 108.627 12 102C12 95.3726 6.62742 90 0 90V80C6.62742 80 12 74.6274 12 68C12 61.3726 6.62742 56 0 56V46C6.62742 46 12 40.6274 12 34C12 27.3726 6.62742 22 0 22V20C0 8.95431 8.95431 0 20 0H323Z",
    fill: "#2878A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponBlue);
export default __webpack_public_path__ + "static/media/coupon_blue.abba3d3e2f29cf8f1b1996ba23e06769.svg";
export { ForwardRef as ReactComponent };